import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { MICROSERVICES } from '@shared/constants/microservices';
import { ToastService, ToastType } from 'cve-ui';
import { catchError, throwError } from 'rxjs';
import { ALLOWED_REQUEST_URL } from '../../domain/constants/allowed-request-url.const';
import { B2cAuthenticationUseCaseService } from '../../features/authentication/aplication/b2c-authentication-use-case.service';
import { ImpersonationService } from '../services/impersonation.service';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
    const authToken = localStorage.getItem('token') || '';
    const b2cService = inject(B2cAuthenticationUseCaseService);
    const impersonationService = inject(ImpersonationService);
    const toastService = inject(ToastService);
    const injector = inject(Injector);
    let headers = req.headers;

    if (checkUrlAllowed(req)) {
        headers = headers.append('Authorization', `Bearer ${authToken}`);
    }
    if (req.url.includes(MICROSERVICES.b2c)) {
        headers = headers.append('Ocp-Apim-Subscription-Key', environment.B2C_FLEETS_HEADER);
    } else {
        headers = headers.append('Ocp-Apim-Subscription-Key', environment.FLEETS_HEADER);
    }
    if (headers !== req.headers) {
        req = req.clone({ headers });
    }

    return next(req).pipe(
        catchError((error: unknown) => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                const translate = injector.get(TranslateService);

                toastService.show({
                    type: ToastType.error,
                    title: translate.instant('shared.toast.session_expired.title'),
                    label: translate.instant('shared.toast.session_expired.label'),
                });

                if (impersonationService.isActive()) {
                    impersonationService.clearSession();
                } else {
                    b2cService.logout();
                }
            }
            return throwError(() => error);
        })
    );
}

function checkUrlAllowed(request: HttpRequest<unknown>) {
    return ALLOWED_REQUEST_URL.some((url) => request.url.includes(url));
}
